export function validateYearsOfProductionTecdoc(from, to) {
  if (!from && !to) return '';
  if (from && !to) return `${from} - ...`;
  if (!from && to) return `... - ${to}`;
  if (from && to) return `${from} - ${to}`;
}
